import * as Yup from "yup";

export const signImSchema = Yup.object({
  username: Yup.string().required("Enter UserName"),
  password: Yup.string().required("Enter Password"),
});
export const forgot = Yup.object({
  email: Yup.string().email("Invalid Email").required("Enter Email"),
});

export const updateProfile = Yup.object({
  email: Yup.string()
    .email("Invalid E-mail")
    .required("Please enter the e-mail"),
  old_password: Yup.string().when({
    is: (old_password) => old_password,
    then: Yup.string().required("Please enter th current password"),
    otherwise: Yup.string().notRequired(),
  }),
  password: Yup.string().when("old_password", {
    is: (old_password) => old_password,
    then: Yup.string().required("Please enter the new password"),
    otherwise: Yup.string().notRequired(),
  }),

  confirm_password: Yup.string()
    .when("password", {
      is: (password) => password,
      then: Yup.string().required("Please verify the new password"),
      otherwise: Yup.string().notRequired(),
    })
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

export const websiteChange = Yup.object({
  email: Yup.string().email("Invalid Email").required("Please enter the email"),
  phone: Yup.string()
    .matches(/^[0-9- ]+$/, "Invalid phone number")
    .min(12, "The phone must contain 12 characters.")
    .required("Please enter the phone"),
});
export const updateNewsleter = Yup.object({
  subject: Yup.string().required("Please enter the subject"),
  body: Yup.string().required("Please enter in the body"),
});

export const updateGift = Yup.object({
  title: Yup.string().required("Please enter the title"),
  description: Yup.string().required("Please enter the description "),
});

export const quizSearch = Yup.object({
  fieldtype: Yup.string().required("Please Select a Column"),
  searchval: Yup.string().required("Please fill the search field"),
});

export const addEmailFun = Yup.object({
  email: Yup.string().email("Invalid Email").required("Please enter the email"),
});

export const updateVoucher = Yup.object({
  Company: Yup.string()
    .min(3, "The company must be at least 3 characters.")
    .max(50, "The company must not greater then 50 characters.")
    .required("The company field is required"),
  Certificate: Yup.string()
    .min(5, "The certificate must be at least 5 characters.")
    .max(6, "The certificate must not greater than 6 characters.")
    .required("The certificate field is required.	"),

  First: Yup.string()
    .min(3, "The first name field must be at least 3 characters.")
    .max(50, "The first name field must not greater then 50 characters.")
    .required("The first name field is required.	"),

  State: Yup.string()
    .min(2, "The city field must be at least 2 characters.")
    .max(20, "The city field must not greater then 20 characters.")
    .required("The state field is required."),
  Job: Yup.number()
    .min(0, "The job field is required.")
    .required("The job field is required."),
  Amount: Yup.number().notRequired(),
  shipCost: Yup.number().notRequired(),

  Concatenated: Yup.string()
    .min(5, "The concatenated must be at least 5 characters.")
    .max(6, "The concatenated must not greater than 6 characters.")
    .required("The concatenated field is required."),

  Last: Yup.string()
    .min(3, "The last name field must be at least 3 characters.")
    .max(50, "The last name field must not greater then 50 characters.")
    .required("The last name field is required."),
  City: Yup.string()
    .min(3, "The city field must be at least 2 characters.")
    .max(30, "The city field must not greater then 30 characters.")
    .required("The city field is required."),
  Zip: Yup.string().required("The zip field is required."),
});

export const importDocument = Yup.object({
  file: Yup.string().required("Please select the file"),
});

export const updateUser = Yup.object({
  First: Yup.string().required("The first name field is required.	"),
  State: Yup.string().required("The state field is required."),
  Last: Yup.string().required("The last name field is required."),
  City: Yup.string().required("The city field is required."),
  email: Yup.string().required("The email field is required."),
  Zip: Yup.number()
    .required("The zip field is required.")
    .min(0, "Invalid zipcode."),
  phone: Yup.number().notRequired().min(0, "Invalid phone."),
  address: Yup.string().required("The address field is required."),
  issuance: Yup.string().required("The issuance field is required."),
  Expiration: Yup.string().required("The Expiration field is required."),
});
